import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SicurezzaArticle from "../pages/article/sicurezza/page";
import CategorieArticle from "../pages/article/categorie/page";
import PrincipiantiArticle from "../pages/article/principianti/page";
import MiglioriProdottiArticle from "../pages/article/prodotti/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guida-itaobuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/itaobuy-spreadsheet-sicurezza",
    element: <SicurezzaArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-categorie",
    element: <CategorieArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-principianti",
    element: <PrincipiantiArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-migliori-prodotti",
    element: <MiglioriProdottiArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;